export const fiscalTest = {
	testing: "Tester les données fiscales {{count}}",
	testingMessage: "Test de {{count}} produit(s) sélectionné(s)...",
	successTitle: "Tester les données fiscales {{count}}",
	successMessage: "Tous les produits ont été testés avec succès!",
	successMainText: "Données fiscales testées avec succès",
	successSubText: "Aucune erreur n'a été trouvée dans les données présentées",
	errorTitle: "Tester les données fiscales {{count}}",
	errorMessage: "Oups... Quelque chose ne s'est pas passé comme prévu.",
	errorSubMessage: "Nous avons trouvé des erreurs dans les données fiscales présentées",
	errorMainText: "Oups... Quelque chose ne s'est pas passé comme prévu.",
	errorSubText: "Nous avons trouvé des erreurs dans les données fiscales présentées",
	success: "Données fiscales testées avec succès",
	error: "Erreur lors du test des données fiscales",
	unknownError: "Erreur inconnue",
};
